import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs/Rx";

@Injectable()
export class LoadingService{
    public isLoading = new BehaviorSubject(false);
    constructor() { }
}